import { render, staticRenderFns } from "./rankStar.vue?vue&type=template&id=e8746b80&scoped=true"
import script from "./rankStar.vue?vue&type=script&lang=js"
export * from "./rankStar.vue?vue&type=script&lang=js"
import style0 from "./rankStar.vue?vue&type=style&index=0&id=e8746b80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8746b80",
  null
  
)

export default component.exports